import { Slide, TextProps, TextPropsOptions } from '@features/powerpoint';

export const imageWithCaption = (
  imagePath: string,
  caption: TextProps['text'],
  position: { h?: number; w?: number; x: number; y: number },
  textOptions: TextPropsOptions = {}
): Slide => {
  const imageWidth = position.w ?? 1.6;
  const imageHeight = position.h ?? 1.6;
  const textboxWidth = 2.5;
  const textXOffset = (textboxWidth - imageWidth) / 2;

  return {
    images: [{ path: imagePath, w: imageWidth, h: imageHeight, ...position }],
    texts: [
      {
        text: caption,
        options: {
          x: position.x - textXOffset,
          y: position.y + imageHeight + 0.05,
          fontSize: 14,
          w: textboxWidth,
          h: 1,
          align: 'center',
          valign: 'top',
          ...textOptions,
        },
      },
    ],
  };
};
